'use client';

import React, { useState, useMemo } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';
import { toast } from 'sonner';
import CartDrawer from './CartDrawer';

const allProducts = [
{ id: 'p-001', name: 'Lumière Radiance Serum', category: 'beauty', subcategory: 'Serums', price: 89, memberPrice: 72, pv: 45, badge: 'Best Seller', stock: 'In Stock', image: "https://images.unsplash.com/photo-1632127649343-1f27f424bf0b", alt: 'Elegant glass serum bottle with gold dropper on white marble surface', rating: 4.9, reviews: 142 },
{ id: 'p-002', name: 'VitaCore Daily Essentials', category: 'wellness', subcategory: 'Supplements', price: 65, memberPrice: 52, pv: 35, badge: 'New', stock: 'In Stock', image: "https://images.unsplash.com/photo-1556758174-b1d75b6d6876", alt: 'Premium supplement bottles on clean white background', rating: 4.7, reviews: 89 },
{ id: 'p-003', name: 'Éclat Brightening Mask', category: 'beauty', subcategory: 'Masks', price: 48, memberPrice: 38, pv: 25, badge: null, stock: 'In Stock', image: "https://images.unsplash.com/photo-1532413301822-a5fe62c07854", alt: 'Luxurious face mask jar with pearl finish on soft pink background', rating: 4.6, reviews: 67 },
{ id: 'p-004', name: 'Harmonie Wellness Tea', category: 'wellness', subcategory: 'Herbal', price: 34, memberPrice: 27, pv: 18, badge: 'Popular', stock: 'In Stock', image: "https://img.rocket.new/generatedImages/rocket_gen_img_116fe75a5-1772116510217.png", alt: 'Premium herbal tea collection in elegant packaging with loose leaf herbs', rating: 4.8, reviews: 203 },
{ id: 'p-005', name: 'Silk Body Ritual Oil', category: 'personal-care', subcategory: 'Body', price: 56, memberPrice: 45, pv: 30, badge: null, stock: 'Out of Stock', image: "https://images.unsplash.com/photo-1629384136243-640bf5eb8f51", alt: 'Amber glass bottle of body oil surrounded by botanical ingredients', rating: 4.5, reviews: 54 },
{ id: 'p-006', name: 'Equilibre Balance Complex', category: 'wellness', subcategory: 'Supplements', price: 78, memberPrice: 62, pv: 40, badge: 'Featured', stock: 'In Stock', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e5acef15-1788372390874.png", alt: 'Sophisticated supplement complex with clinical packaging', rating: 4.7, reviews: 118 },
{ id: 'p-007', name: 'Maison Lifestyle Candle', category: 'lifestyle', subcategory: 'Home', price: 42, memberPrice: 34, pv: 22, badge: null, stock: 'In Stock', image: "https://images.unsplash.com/photo-1594360439343-3f62887f4df6", alt: 'Luxury scented candle in matte black vessel on marble surface', rating: 4.4, reviews: 38 },
{ id: 'p-008', name: 'Pur Cleanse Foam Wash', category: 'personal-care', subcategory: 'Cleansers', price: 38, memberPrice: 30, pv: 20, badge: 'New', stock: 'In Stock', image: "https://img.rocket.new/generatedImages/rocket_gen_img_10ac1dfcb-1772216203794.png", alt: 'Minimalist cleanser bottle in frosted glass with botanical extract drops', rating: 4.6, reviews: 71 },
{ id: 'p-009', name: 'Collagen Revive Complex', category: 'wellness', subcategory: 'Supplements', price: 92, memberPrice: 74, pv: 48, badge: 'Premium', stock: 'In Stock', image: "https://img.rocket.new/generatedImages/rocket_gen_img_160435621-1765173221858.png", alt: 'Premium collagen supplement in elegant white packaging', rating: 4.9, reviews: 156 },
{ id: 'p-010', name: 'Velvet Lip Treatment', category: 'beauty', subcategory: 'Lips', price: 28, memberPrice: 22, pv: 14, badge: null, stock: 'In Stock', image: "https://images.unsplash.com/photo-1595425945187-9fbf96e87a2a", alt: 'Luxurious lip treatment in gold packaging on white surface', rating: 4.5, reviews: 92 },
{ id: 'p-011', name: 'Detox Charcoal Scrub', category: 'personal-care', subcategory: 'Body', price: 44, memberPrice: 35, pv: 23, badge: null, stock: 'Low Stock', image: "https://images.unsplash.com/photo-1632127421044-d918b3268071", alt: 'Dark charcoal face scrub in minimalist packaging on stone surface', rating: 4.3, reviews: 45 },
{ id: 'p-012', name: 'Aromatherapy Diffuser Set', category: 'lifestyle', subcategory: 'Home', price: 68, memberPrice: 54, pv: 36, badge: 'Popular', stock: 'In Stock', image: "https://images.unsplash.com/photo-1636724500314-ee58de4715cf", alt: 'Elegant ceramic aromatherapy diffuser with essential oil bottles', rating: 4.7, reviews: 83 }];


const categoryFilters = [
{ id: 'filter-all', label: 'All Categories', value: 'all' },
{ id: 'filter-wellness', label: 'Wellness', value: 'wellness' },
{ id: 'filter-beauty', label: 'Beauty', value: 'beauty' },
{ id: 'filter-personal-care', label: 'Personal Care', value: 'personal-care' },
{ id: 'filter-lifestyle', label: 'Lifestyle', value: 'lifestyle' }];


const sortOptions = [
{ id: 'sort-popular', label: 'Most Popular', value: 'popular' },
{ id: 'sort-price-asc', label: 'Price: Low to High', value: 'price-asc' },
{ id: 'sort-price-desc', label: 'Price: High to Low', value: 'price-desc' },
{ id: 'sort-pv-high', label: 'Highest PV', value: 'pv-high' },
{ id: 'sort-newest', label: 'Newest', value: 'newest' }];


interface CartItem {
  id: string;
  name: string;
  price: number;
  qty: number;
  image: string;
  alt: string;
}

export default function ProductCatalogContent() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [sortBy, setSortBy] = useState('popular');
  const [search, setSearch] = useState('');
  const [priceRange, setPriceRange] = useState<[number, number]>([0, 100]);
  const [inStockOnly, setInStockOnly] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [wishlist, setWishlist] = useState<string[]>([]);
  const [viewMode, setViewMode] = useState<'grid' | 'list'>('grid');

  const addToCart = (product: typeof allProducts[0]) => {
    setCartItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      if (existing) return prev.map((i) => i.id === product.id ? { ...i, qty: i.qty + 1 } : i);
      return [...prev, { id: product.id, name: product.name, price: product.memberPrice, qty: 1, image: product.image, alt: product.alt }];
    });
    toast.success(`${product.name} added to cart`);
    setCartOpen(true);
  };

  const toggleWishlist = (id: string) => {
    setWishlist((prev) => prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]);
  };

  const filtered = useMemo(() => {
    let result = allProducts.filter((p) => {
      if (activeCategory !== 'all' && p.category !== activeCategory) return false;
      if (inStockOnly && p.stock === 'Out of Stock') return false;
      if (p.memberPrice < priceRange[0] || p.memberPrice > priceRange[1] * 10) return false;
      if (search && !p.name.toLowerCase().includes(search.toLowerCase())) return false;
      return true;
    });

    switch (sortBy) {
      case 'price-asc':result = [...result].sort((a, b) => a.memberPrice - b.memberPrice);break;
      case 'price-desc':result = [...result].sort((a, b) => b.memberPrice - a.memberPrice);break;
      case 'pv-high':result = [...result].sort((a, b) => b.pv - a.pv);break;
      default:result = [...result].sort((a, b) => b.reviews - a.reviews);
    }
    return result;
  }, [activeCategory, sortBy, search, priceRange, inStockOnly]);

  const cartTotal = cartItems.reduce((sum, i) => sum + i.price * i.qty, 0);
  const cartCount = cartItems.reduce((sum, i) => sum + i.qty, 0);

  return (
    <>
      <CartDrawer
        open={cartOpen}
        onClose={() => setCartOpen(false)}
        items={cartItems}
        setItems={setCartItems}
        total={cartTotal} />


      <div className="max-w-screen-2xl mx-auto px-6 lg:px-10 py-8">
        {/* Page header */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="text-2xl font-bold text-foreground mb-1">Product Catalog</h1>
            <p className="text-sm text-muted-foreground">{filtered.length} products — member pricing shown</p>
          </div>
          <button
            onClick={() => setCartOpen(true)}
            className="relative flex items-center gap-2 btn-primary px-5 py-2.5 rounded-xl text-sm font-semibold">

            <Icon name="ShoppingBagIcon" size={18} />
            Cart
            {cartCount > 0 &&
            <span className="bg-white text-primary text-xs font-bold px-1.5 py-0.5 rounded-full tabular-nums">
                {cartCount}
              </span>
            }
          </button>
        </div>

        {/* Attribution banner */}
        <div className="mb-6 p-3 rounded-xl bg-primary/8 border border-primary/20 flex items-center gap-3">
          <Icon name="InformationCircleIcon" size={16} className="text-primary flex-shrink-0" />
          <p className="text-xs text-foreground">
            Shopping from <strong>Maria Santos's store</strong> — your purchase supports Maria directly.{' '}
            <button className="text-primary font-medium hover:underline">Shop from corporate store instead</button>
          </p>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          {/* Sidebar filters */}
          <aside className="lg:w-56 xl:w-64 flex-shrink-0 space-y-5">
            {/* Search */}
            <div className="card-elevated rounded-xl p-4">
              <label className="richesse-label">Search Products</label>
              <div className="relative">
                <Icon name="MagnifyingGlassIcon" size={15} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
                <input
                  type="search"
                  placeholder="Product name..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="richesse-input pl-8 text-sm" />

              </div>
            </div>

            {/* Categories */}
            <div className="card-elevated rounded-xl p-4">
              <p className="richesse-label mb-3">Category</p>
              <div className="space-y-1.5">
                {categoryFilters.map((cat) =>
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.value)}
                  className={`w-full text-left px-3 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                  activeCategory === cat.value ?
                  'bg-primary/10 text-primary' : 'text-muted-foreground hover:bg-muted hover:text-foreground'}`
                  }>

                    {cat.label}
                  </button>
                )}
              </div>
            </div>

            {/* Price range */}
            <div className="card-elevated rounded-xl p-4">
              <p className="richesse-label mb-3">Member Price Range</p>
              <div className="space-y-3">
                <div className="flex items-center justify-between text-xs text-muted-foreground">
                  <span>${priceRange[0]}</span>
                  <span>${priceRange[1] * 10}+</span>
                </div>
                <input
                  type="range"
                  min={0}
                  max={10}
                  value={priceRange[1]}
                  onChange={(e) => setPriceRange([priceRange[0], Number(e.target.value)])}
                  className="w-full accent-primary" />

              </div>
            </div>

            {/* Availability */}
            <div className="card-elevated rounded-xl p-4">
              <p className="richesse-label mb-3">Availability</p>
              <label className="flex items-center gap-2.5 cursor-pointer">
                <input
                  type="checkbox"
                  checked={inStockOnly}
                  onChange={(e) => setInStockOnly(e.target.checked)}
                  className="w-4 h-4 rounded accent-primary" />

                <span className="text-sm text-foreground">In Stock Only</span>
              </label>
            </div>

            {/* PV info */}
            <div className="card-elevated rounded-xl p-4 bg-primary/5 border-primary/20">
              <Icon name="InformationCircleIcon" size={16} className="text-primary mb-2" />
              <p className="text-xs font-semibold text-foreground mb-1">About PV</p>
              <p className="text-[11px] text-muted-foreground leading-relaxed">
                Personal Volume (PV) determines your commission tier. Higher PV products contribute more to your monthly qualification.
              </p>
            </div>
          </aside>

          {/* Product grid */}
          <div className="flex-1 min-w-0">
            {/* Sort + view controls */}
            <div className="flex items-center justify-between mb-5 gap-3">
              <p className="text-sm text-muted-foreground">
                <span className="font-semibold text-foreground">{filtered.length}</span> products
              </p>
              <div className="flex items-center gap-2">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="richesse-input py-1.5 text-xs w-44">

                  {sortOptions.map((opt) =>
                  <option key={opt.id} value={opt.value}>{opt.label}</option>
                  )}
                </select>
                <div className="flex border border-border rounded-lg overflow-hidden">
                  {(['grid', 'list'] as const).map((mode) =>
                  <button
                    key={`view-${mode}`}
                    onClick={() => setViewMode(mode)}
                    className={`px-3 py-2 transition-colors ${viewMode === mode ? 'bg-primary text-primary-foreground' : 'bg-card text-muted-foreground hover:bg-muted'}`}
                    aria-label={`${mode} view`}>

                      <Icon name={mode === 'grid' ? 'Squares2X2Icon' : 'ListBulletIcon'} size={16} />
                    </button>
                  )}
                </div>
              </div>
            </div>

            {/* Products */}
            {filtered.length === 0 ?
            <div className="card-elevated rounded-xl p-16 text-center">
                <Icon name="CubeIcon" size={40} className="text-muted-foreground/40 mx-auto mb-4" />
                <p className="text-base font-semibold text-muted-foreground mb-1">No products found</p>
                <p className="text-sm text-muted-foreground mb-4">Try adjusting your filters or search term</p>
                <button onClick={() => {setActiveCategory('all');setSearch('');setInStockOnly(false);}} className="btn-primary px-5 py-2.5 rounded-lg text-sm font-semibold">
                  Clear Filters
                </button>
              </div> :

            <div className={viewMode === 'grid' ? 'grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4' : 'space-y-3'
            }>
                {filtered.map((product) =>
              viewMode === 'grid' ?
              <div key={product.id} className="product-card card-elevated card-hover overflow-hidden group">
                      <div className="relative overflow-hidden bg-muted" style={{ aspectRatio: '4/5' }}>
                        <AppImage
                    src={product.image}
                    alt={product.alt}
                    fill
                    sizes="(max-width: 640px) 100vw, (max-width: 1280px) 33vw, 25vw"
                    className="product-card-img object-cover" />

                        <div className="absolute inset-0 bg-accent/0 group-hover:bg-accent/10 transition-colors duration-300" />
                        {product.badge &&
                  <span className="absolute top-3 left-3 richesse-badge bg-primary/15 text-primary text-[10px]">
                            {product.badge}
                          </span>
                  }
                        {product.stock === 'Low Stock' &&
                  <span className="absolute top-3 right-3 richesse-badge bg-warning-bg text-warning text-[10px]">
                            Low Stock
                          </span>
                  }
                        {product.stock === 'Out of Stock' &&
                  <div className="absolute inset-0 bg-background/60 flex items-center justify-center">
                            <span className="text-sm font-semibold text-muted-foreground bg-card px-3 py-1.5 rounded-full border border-border">
                              Out of Stock
                            </span>
                          </div>
                  }
                        <button
                    onClick={() => toggleWishlist(product.id)}
                    className="absolute bottom-3 right-3 w-8 h-8 rounded-full bg-card/90 backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-200"
                    aria-label="Wishlist">

                          <Icon name="HeartIcon" size={15} className={wishlist.includes(product.id) ? 'text-rose-500' : 'text-muted-foreground'} variant={wishlist.includes(product.id) ? 'solid' : 'outline'} />
                        </button>
                      </div>
                      <div className="p-4">
                        <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider mb-1 capitalize">{product.subcategory}</p>
                        <h3 className="text-sm font-semibold text-foreground mb-1 leading-snug">{product.name}</h3>
                        <div className="flex items-center gap-1 mb-3">
                          <Icon name="StarIcon" size={11} className="text-primary" variant="solid" />
                          <span className="text-[11px] font-medium text-foreground">{product.rating}</span>
                          <span className="text-[11px] text-muted-foreground">({product.reviews})</span>
                        </div>
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-baseline gap-1.5">
                            <span className="text-base font-bold text-foreground tabular-nums">${product.memberPrice}</span>
                            <span className="text-xs text-muted-foreground line-through tabular-nums">${product.price}</span>
                          </div>
                          <span className="richesse-badge bg-primary/10 text-primary text-[10px]">{product.pv} PV</span>
                        </div>
                        <button
                    onClick={() => product.stock !== 'Out of Stock' && addToCart(product)}
                    disabled={product.stock === 'Out of Stock'}
                    className={`w-full py-2 rounded-lg text-xs font-semibold transition-all duration-200 ${product.stock !== 'Out of Stock' ? 'btn-primary' : 'bg-muted text-muted-foreground cursor-not-allowed'}`}>

                          {product.stock !== 'Out of Stock' ? 'Add to Cart' : 'Notify Me'}
                        </button>
                      </div>
                    </div> :

              <div key={product.id} className="card-elevated rounded-xl p-4 flex items-center gap-4 group hover:shadow-card-hover transition-shadow">
                      <div className="relative w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                        <AppImage src={product.image} alt={product.alt} fill sizes="64px" className="object-cover" />
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="flex items-start justify-between gap-2">
                          <div>
                            <p className="text-[10px] font-medium text-muted-foreground uppercase tracking-wider mb-0.5">{product.subcategory}</p>
                            <h3 className="text-sm font-semibold text-foreground">{product.name}</h3>
                          </div>
                          {product.badge && <span className="richesse-badge bg-primary/10 text-primary text-[10px] flex-shrink-0">{product.badge}</span>}
                        </div>
                        <div className="flex items-center gap-3 mt-1.5">
                          <div className="flex items-baseline gap-1.5">
                            <span className="text-sm font-bold text-foreground tabular-nums">${product.memberPrice}</span>
                            <span className="text-xs text-muted-foreground line-through tabular-nums">${product.price}</span>
                          </div>
                          <span className="text-[10px] font-medium text-primary">{product.pv} PV</span>
                          <span className={`richesse-badge text-[10px] ${product.stock === 'In Stock' ? 'status-active' : product.stock === 'Low Stock' ? 'status-pending' : 'status-inactive'}`}>{product.stock}</span>
                        </div>
                      </div>
                      <button
                  onClick={() => product.stock !== 'Out of Stock' && addToCart(product)}
                  disabled={product.stock === 'Out of Stock'}
                  className={`flex-shrink-0 px-4 py-2 rounded-lg text-xs font-semibold transition-all ${product.stock !== 'Out of Stock' ? 'btn-primary' : 'bg-muted text-muted-foreground cursor-not-allowed'}`}>

                        Add to Cart
                      </button>
                    </div>

              )}
              </div>
            }

            {/* Pagination */}
            {filtered.length > 0 &&
            <div className="flex items-center justify-between mt-8">
                <p className="text-xs text-muted-foreground">Showing 1–{filtered.length} of {filtered.length} products</p>
                <div className="flex items-center gap-1">
                  {['1', '2', '3', '4'].map((p) =>
                <button key={`catalog-page-${p}`} className={`w-8 h-8 rounded-lg text-xs font-medium transition-colors ${p === '1' ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-muted'}`}>
                      {p}
                    </button>
                )}
                  <button className="w-8 h-8 rounded-lg text-xs font-medium text-muted-foreground hover:bg-muted transition-colors">
                    <Icon name="ChevronRightIcon" size={14} />
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>);

}